import styled from "styled-components";

export const SAddNewItemModalContent = styled.div`
  padding: 16px 24px;
`;
